import { postJson } from './httpClient';

/**
 * Create order via DinDin web API (authenticated customer).
 * Route: POST .../dindin-web/orders (Bearer Sanctum token).
 *
 * @param {Record<string, unknown>} payload - From buildWebOrderPayload()
 * @param {string} token - Customer Bearer token
 * @param {RequestInit} [fetchInit]
 * @returns {Promise<{ order?: object }>}
 */
export async function createWebOrder(payload, token, fetchInit = {}) {
  const t = String(token || '').trim();
  if (!t) throw new Error('Not signed in');

  const json = await postJson('/orders', {
    body: payload,
    token: t,
    globalLoading: false,
    ...fetchInit,
  });

  if (!json?.success) {
    throw new Error(json?.message || 'Could not place order');
  }

  return json?.data ?? {};
}
